import DesignTokens from '@tableau/design-tokens';
import {
    RadioButtonWithLabelGroupWidget,
    TabStyles} from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CredentialOption } from '~src/connectivity/components/EditConnection/IEditConnectionDialog';
import { IOAuthCredential } from '~src/connectivity/serverApi/types/OAuth/IOAuthCredential';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

import { OAuthAccountDropdown } from './OAuthAccountDropdown';

const option: string = cssClass('edit-oauth-connection', 'embedded-option', {
    marginBottom: TabStyles.Sizing.BaseUnit * 2,
});

const optionText: string = cssClass('edit-oauth-connection', 'option-text', {
    marginBottom: TabStyles.Sizing.BaseUnit,
});

const optionSubText: string = cssClass('edit-oauth-connection', 'option-subtext', {
    color: applyColor(DesignTokens.color.font.default.secondary, TabStyles.Typography.Color.Secondary)
});

const authenticationLabel: string = cssClass('edit-oauth-connection', 'authentication-label', {
    marginTop: TabStyles.Sizing.BaseUnit * 3,
    marginBottom: TabStyles.Sizing.BaseUnit * 2,
    fontWeight: 'bold'
});

export type OAuthAccountPickerProps = Readonly<{
    credentialNoValueOptionText: string;
    currentConnectionTypeDisplayName: string;
    addNewOAuthCredentialOptionValue: string;
    credentialId: string;
    credentials: IOAuthCredential[];
    credentialOption: CredentialOption;
    handleToggleChange: (isPasswordEmbedded: boolean) => void;
    handleCredentialIdChange: (newCredentialId: string) => void;
}>;

// W-22483245: the "Embedded credentials" + "No authentication" two-radio group with the account
// dropdown under the embedded radio. Moved out of EditOAuthConnection so both the stock OAuth dialog
// and the WIF-eligible dialog import one component instead of duplicating it.
export function OAuthAccountPicker(props: OAuthAccountPickerProps) {
    return (
        <RadioButtonWithLabelGroupWidget
            className={authenticationLabel}
            label={<div className={authenticationLabel}>{Messages.authentication()}</div>}
            buttonList={[
                {
                    label: <div className={optionText}>{Messages.editDataConnections_generic_embedCredential()}</div>,
                    detail:
                        <div className={option}>
                            <OAuthAccountDropdown
                                credentialOption={props.credentialOption}
                                credentials={props.credentials}
                                credentialId={props.credentialId}
                                credentialNoValueOptionText={props.credentialNoValueOptionText}
                                addNewOAuthCredentialOptionValue={props.addNewOAuthCredentialOptionValue}
                                currentConnectionTypeDisplayName={props.currentConnectionTypeDisplayName}
                                ariaLabel={Messages.editDataConnections_generic_embedCredential()}
                                handleCredentialIdChange={props.handleCredentialIdChange}
                            />
                            <label className={optionSubText}>{Messages.editDataConnections_generic_describeEmbedCredential()}</label>
                        </div>,
                    testId: 'embedded',
                    value: true,
                    disabled: (!props.credentials || props.credentials.length === 0) && !props.addNewOAuthCredentialOptionValue,
                },
                {
                    label: <div className={optionText}>{Messages.editDataConnections_generic_noCredential()}</div>,
                    detail:
                        <div className={option}>
                            <label className={optionSubText}>{Messages.editDataConnections_generic_describeNoCredential()}</label>
                        </div>,
                    testId: 'no-auth',
                    value: false,
                },
            ]}
            checkedIndex={props.credentialOption === 'oauth' || props.credentialOption === 'keypair' ? 0 : 1}
            handleChange={(value) => props.handleToggleChange(value)}
        />
    );
}
